export default __webpack_public_path__ + "static/media/flyingRock9.da08d782.webp";